module.exports = __webpack_public_path__ + "media/images/icons/down-4840cf3d0db26716e073fd3946f2b3b0.png";